import {useArabicRulesInCombineNode} from "@/components/widgets/list_download/common.js";

function washFn(walkedNode, item){
  if(walkedNode.modeData && walkedNode.modeData[item.flag]){
    walkedNode.modeData[item.flag] = useArabicRulesInCombineNode({
      componentName: item.componentName,
      data: walkedNode.modeData[item.flag]
    }).data
  }
}

export function washData(walkedNode){
  if(walkedNode._type === 'list_product_style1'){
    [{
      flag: 'productList_listItem_title',
      componentName: 'text_title',
    },{
      flag: 'productList_listItem_paragraph',
      componentName: 'text_paragraph',
    },{
      flag: 'productList_listItem_button',
      componentName: 'button_text',
    },{
      flag: 'productList_mask_title',
      componentName: 'text_title',
    },{
      flag: 'productList_mask_paragraph',
      componentName: 'text_paragraph',
    }].forEach((item)=>{
      washFn(walkedNode, item)
    })
  }
  else if(
      walkedNode._type === 'list_product_style2' ||
      walkedNode._type === 'list_product_style3' ||
      walkedNode._type === 'list_product_style4' ||
      walkedNode._type === 'list_product_style5' ||
      walkedNode._type === 'list_product_style6' ||
      walkedNode._type === 'list_product_style8'
  ){

    [{
      flag: 'productList_listItem_title',
      componentName: 'text_title',
    },{
      flag: 'productList_listItem_paragraph',
      componentName: 'text_paragraph',
    },{
      flag: 'productList_listItem_button',
      componentName: 'button_text',
    }].forEach((item)=>{
      washFn(walkedNode, item)
    })
  }else if(
      walkedNode._type === 'list_product_style9'
  ){

    [{
      flag: 'productList_listItem_title',
      componentName: 'text_title',
    },{
      flag: 'productList_listItem_button',
      componentName: 'button_text',
    }].forEach((item)=>{
      washFn(walkedNode, item)
    })
  }else if(
      walkedNode._type === 'list_product_style12'
  ){

    [{
      flag: 'productList_listItem_title',
      componentName: 'text_title',
    },{
      flag: 'productList_listItem_paragraph',
      componentName: 'text_paragraph',
    },{
      flag: 'productList_listItem_download_button',
      componentName: 'button_text_icon',
    },{
      flag: 'productList_listItem_view_more_button',
      componentName: 'button_text_icon',
    }].forEach((item)=>{
      washFn(walkedNode, item)
    })
  }
}
